import {
  LIST_SURVEYS,
  GET_SURVEY,
  CURR_TAGS,
  GET_SURVEY_SUMMARY,
  SURVEY_RESPONSES,
  SURVEY_RESPONSES_SUMMARY,
  LIST_SURVEYS_FILTER_TAGS,
  GET_ALL_TAGS,
  UPDATE_SEARCH_TAGS,
  CURR_SURVEY,
  GET_QUESTION_CONFIG,
  GET_SURVEY_DESCRIPTION,
  GET_QUESTION_PRO,
  LIST_CONFIG_SURVEY,
  SURVEY_BY_ORGANISATION,
  DB_AUTOCOMPLETE_TAG,
  ASSESSMENT_QUESTIONS,
  ASSESSMENT_QUESTION_GROUP,
  DB_AUTOCOMPLETE_TAG_ASSESSMENT,
} from "constants/ActionTypes"

const INIT_STATE = {
  db_surveys: [],
  db_surveys_filter_tags: [],
  db_active_surveys: [],
  db_curr_survey: null,
  db_curr_tags: [],
  db_all_tags: [],
  db_input_tags_search_results: [],
  limesurvey_curr_survey: null,
  limesurvey_curr_categories: [],
  limesurvey_curr_freetext: [],
  limesurvey_curr_result: [],
  limesurvey_survey_responses: [],
  limesurvey_survey_responses_summary: null,
  limesurvey_survey_summary: null,
  limesurvey_survey_questions: [],
  limesurvey_survey_question_config: [],
  survey_description: [],
  question_property: [],
  config_surveys: [],
  surveys_by_organisation: [],
  db_tags_autocomplete: [],
  db_question_group: null,
  db_tag_autocomplete_assessment: [],
}

export default (state = INIT_STATE, action) => {
  switch(action.type) {
    
    case LIST_SURVEYS: {
      return {
        ...state,
        db_surveys: action.payload.surveys,
        db_active_surveys: action.payload.active_surveys
      }
    }

    case LIST_SURVEYS_FILTER_TAGS: {
      return {
        ...state,
        db_surveys_filter_tags: action.payload.tags
      }
    }

    case GET_ALL_TAGS: {
      return {
        ...state,
        db_all_tags: action.payload.tags
      }
    }

    case UPDATE_SEARCH_TAGS: {
      return {
        ...state,
        db_input_tags_search_results: action.payload.tags
      }
    }

    case GET_SURVEY: {
      return {
        ...state,
        db_curr_survey: action.payload.survey
      }
    }

    case CURR_SURVEY: {
      return {
        ...state,
        limesurvey_curr_survey: action.payload
      }
    }

    case CURR_TAGS: {
      return {
        ...state,
        db_curr_tags: action.payload.tags 
      }
    }

    case GET_SURVEY_SUMMARY: {
      return {
        ...state,
        limesurvey_survey_summary: action.payload.survey_summary
      }
    }

    case SURVEY_RESPONSES: {
      return {
        ...state,
        limesurvey_survey_responses: action.payload.responses
      }
    }
    case SURVEY_RESPONSES_SUMMARY: {
      return {
        ...state,
        limesurvey_survey_responses_summary: action.payload.responses_summary
      }
    }
    case ASSESSMENT_QUESTIONS: {
      return {
        ...state,
        limesurvey_survey_questions: action.payload.questions
      }
    }
    case GET_QUESTION_CONFIG: {
      return {
        ...state,
        limesurvey_survey_question_config: action.payload.limesurvey_survey_question_config,
        limesurvey_curr_categories: action.payload.limesurvey_curr_categories,
        limesurvey_curr_freetext: action.payload.limesurvey_curr_freetext,
        limesurvey_curr_result: action.payload.limesurvey_curr_result,
      }
    }
    case GET_SURVEY_DESCRIPTION: {
      return {
        ...state,
        survey_description: action.payload.survey_description,
      }
    }
    case GET_QUESTION_PRO: {
      return {
        ...state,
        question_property: action.payload.property,
      }
    }
    case LIST_CONFIG_SURVEY: {
      return{
        ...state,
        config_surveys: action.payload.config_survey,
      }
    }
    case SURVEY_BY_ORGANISATION: {
      return{
        ...state,
        surveys_by_organisation: action.payload.surveys_by_organisation,
      }
    }
    case DB_AUTOCOMPLETE_TAG: {
      return{
        ...state,
        db_tags_autocomplete: action.payload.tags,
      }
    }

    case ASSESSMENT_QUESTION_GROUP: {
      return {
        ...state,
        db_question_group: action.payload.result
      }
    }

    case DB_AUTOCOMPLETE_TAG_ASSESSMENT: {
      return {
        ...state,
        db_tag_autocomplete_assessment: action.payload.tags
      }
    }
    default:
      return state;
  }
}